import AcompanhamentoProjeto from './componentes/AcompanhamentoProjeto.vue';
import AcompanhamentoProjetoLista from './componentes/AcompanhamentoProjetoLista.vue';
import AcompanhamentoProjetoForm from './componentes/AcompanhamentoProjetoForm.vue';

export default {
  path: '/acompanhamento-projeto',
  component: AcompanhamentoProjeto,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: AcompanhamentoProjetoLista,
      name: 'acompanhamento-projeto',
    },
    {
      path: ':id',
      component: AcompanhamentoProjetoForm,
      name: 'acompanhamento-projeto.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acompanhamento-projeto/rotas.js